import React from 'react';
import { formatPhoneWhileTyping } from '../utils/phoneNumber';

/**
 * Portal phone field: formats 10-digit numbers as (555) 123-4567 as the user types.
 */
const PhoneNumberInput = ({
  value,
  onChange,
  name,
  id,
  className,
  style,
  placeholder = 'e.g. (405) 555-1234',
  disabled = false,
  required = false,
  autoComplete = 'tel',
}) => {
  const handleChange = (event) => {
    const next = formatPhoneWhileTyping(event.target.value);
    if (!onChange) {
      return;
    }
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name || event.target.name,
        value: next,
      },
    });
  };

  return (
    <input
      type="tel"
      inputMode="numeric"
      autoComplete={autoComplete}
      name={name}
      id={id}
      className={className}
      style={style}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      value={formatPhoneWhileTyping(value)}
      onChange={handleChange}
    />
  );
};

export default PhoneNumberInput;
